import {
  GET_JOBS,
  GET_JOBS_SUCCESS,
  GET_JOBS_FAILURE,
  CREATE_JOB,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_FAILURE,
  UPDATE_JOB,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAILURE,
  RESET_JOBS_STATE,
} from './actionTypes';

export const getJobs = accessToken => ({
  type: GET_JOBS,
  accessToken,
});

export const getJobsSuccess = jobs => ({
  type: GET_JOBS_SUCCESS,
  jobs,
});

export const getJobsFailure = () => ({
  type: GET_JOBS_FAILURE,
});

export const createJob = (accessToken, payload) => ({
  type: CREATE_JOB,
  accessToken,
  payload,
});

export const createJobSuccess = job => ({
  type: CREATE_JOB_SUCCESS,
  job,
});

export const createJobFailure = () => ({
  type: CREATE_JOB_FAILURE,
});

export const updateJob = (accessToken, jobId, payload) => ({
  type: UPDATE_JOB,
  accessToken,
  jobId,
  payload,
});

export const updateJobSuccess = job => ({
  type: UPDATE_JOB_SUCCESS,
  job,
});

export const updateJobFailure = () => ({
  type: UPDATE_JOB_FAILURE,
});

export const resetJobsState = () => ({
  type: RESET_JOBS_STATE,
});
